import { cn } from '@/lib/utils';
import { memo } from 'react';
import { Input, InputProps } from '../ui/input';
import InputPassword from './input-password';

type ExcludeInputProps = Omit<InputProps, 'prefix'>;
type InputPrefixProps = ExcludeInputProps & {
    isInputPassword?: boolean;
    prefix?: React.ReactNode;
    wrapperClassName?: string;
};

const InputPrefix = (props: InputPrefixProps) => {
    const { isInputPassword, prefix, wrapperClassName, ...rest } = props;

    return (
        <div className={cn('relative [&>*]:outline-none', wrapperClassName)}>
            {prefix && (
                <span
                    className={cn(
                        'absolute inset-y-0 left-2.5 top-1/2 z-10 flex -translate-y-1/2 items-center justify-center text-gray-700',
                        {
                            'opacity-60': rest.disabled,
                        }
                    )}
                >
                    {prefix}
                </span>
            )}

            {isInputPassword ? (
                <InputPassword
                    {...rest}
                    className={cn(rest.className, 'pl-8')}
                />
            ) : (
                <Input {...rest} className={cn(rest.className, 'pl-8')} />
            )}
        </div>
    );
};

export default memo(InputPrefix);
